import React from 'react';
import FilterBar from '../FilterBar/FilterBar';
import SearchBox from '../SearchBox/SearchBox';
import './StageTabs.css';

function StageTabs({ 
  stages, 
  activeStage, 
  contacts,
  onStageChange,
  // Filter/search props
  searchQuery,
  filterSource,
  filterTaskStatus,
  filterDateRange,
  onSearchChange,
  onSourceChange,
  onTaskStatusChange,
  onDateRangeChange,
  onClearFilters,
  activeFilterCount
}) {
  return (
    <div className="stage-tabs-row">
      <div className="stage-tabs">
        {stages.map((stage) => {
          const count = stage.key === 'all' 
            ? contacts.length 
            : contacts.filter(c => c.status === stage.key).length;
          return (
            <button
              key={stage.key}
              className={`stage-tab ${activeStage === stage.key ? 'active' : ''}`}
              onClick={() => onStageChange(stage.key)}
              style={{ '--stage-color': stage.color }}
            >
              <span className="stage-icon">{stage.icon}</span>
              <span className="stage-name">{stage.name}</span>
              <span className="stage-count">({count})</span>
            </button>
          );
        })}
      </div>
      
      <div className="right-controls">
        <FilterBar
          contacts={contacts}
          filterSource={filterSource}
          filterTaskStatus={filterTaskStatus}
          filterDateRange={filterDateRange}
          onSourceChange={onSourceChange}
          onTaskStatusChange={onTaskStatusChange}
          onDateRangeChange={onDateRangeChange}
          onClearAll={onClearFilters}
          activeFilterCount={activeFilterCount}
        />
        <SearchBox
          value={searchQuery}
          onChange={onSearchChange}
        />
      </div>
    </div>
  );
}

export default StageTabs;

